import { PRODDOMAIN } from "@/utils";
import axios from "axios";
import { GetServerSideProps } from "next";
import Head from "next/head";

const getServerSideProps: GetServerSideProps = async context => {
  const lang = context.locale as any

  const { data } = await axios.get(`${PRODDOMAIN}/getHomeMenuDetail`, {
    params: {
      path: !!context.resolvedUrl ? context.resolvedUrl : '/',
    },
    headers: {
      lang
    }
  });

  let newData = {}
  if (data.code == 200) {
    newData = {
      ...data.data,
      meta_title: data.data?.meta_title
        || (lang === 'cn' ? "IPB国际粉体、散料、流体加工展览会"
          : "IPB国际粉体、散料、流体加工展览会"),
      title: data.data?.title,
      content: data.data?.content,
      // brief: data.data[`brief_${lang}`],
      meta_desc: data.data?.meta_desc
        || (lang === 'cn' ? "IPB国际粉体、散料、流体加工展览会"
          : "IPB国际粉体、散料、流体加工展览会"),
      meta_kws: data.data?.meta_kws
        || (lang === 'cn' ?
          "IPB国际粉体、散料、流体加工展览会"
          : "IPB国际粉体、散料、流体加工展览会")
    }
  }

  return {
    props: {
      navDetail: newData || {},
    },
  };
};

const getHead = (navDetail: any) => {
  return (<Head>
    <title>{navDetail?.meta_title} </title>
    <meta name="keywords" content={navDetail?.meta_kws} />
    <meta name="description" content={navDetail?.meta_desc} />
  </Head>)
}
export { getHead, getServerSideProps }
